export default __webpack_public_path__ + "static/media/sharePoint.a7f62ec8.svg";